(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this)); 
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["protein_chief"] && !Shopify.designMode) return;
  try {
    
 const DesktopBackgroundImageURL =
 'https://cdn.shopify.com/s/files/1/0603/9735/5095/files/ddsd.png?v=1748865385';

 const MobileBackgroundImageURL =
 'https://cdn.shopify.com/s/files/1/0603/9735/5095/files/image_19.png?v=1748865704';

 const btnText = 'Order Now - $15 OFF';

 const slidingElement = [
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_174.png?v=1684622299',
 text: 'No Hormones or Antibiotics',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_173.png?v=1684622421',
 text: '100% Grass Fed Beef',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_172.png?v=1684622432',
 text: 'Wild Caught & Organic Fish Sustainable Seafood',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_171.png?v=1684622443',
 text: 'Certified Halal By HMA',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_170.png?v=1684622456',
 text: 'Support Local Ontario Farmers',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_169.png?v=1684622467',
 text: 'Fresh Ontario Sourced Produced',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_174.png?v=1684622299',
 text: 'No Hormones or Antibiotics',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_173.png?v=1684622421',
 text: '100% Grass Fed Beef',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_172.png?v=1684622432',
 text: 'Wild Caught & Organic Fish Sustainable Seafood',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_171.png?v=1684622443',
 text: 'Certified Halal By HMA',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_170.png?v=1684622456',
 text: 'Support Local Ontario Farmers',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_169.png?v=1684622467',
 text: 'Fresh Ontario Sourced Produced',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_174.png?v=1684622299',
 text: 'No Hormones or Antibiotics',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_173.png?v=1684622421',
 text: '100% Grass Fed Beef',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_172.png?v=1684622432',
 text: 'Wild Caught & Organic Fish Sustainable Seafood',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_171.png?v=1684622443',
 text: 'Certified Halal By HMA',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_170.png?v=1684622456',
 text: 'Support Local Ontario Farmers',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_169.png?v=1684622467',
 text: 'Fresh Ontario Sourced Produced',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_174.png?v=1684622299',
 text: 'No Hormones or Antibiotics',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_173.png?v=1684622421',
 text: '100% Grass Fed Beef',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_172.png?v=1684622432',
 text: 'Wild Caught & Organic Fish Sustainable Seafood',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_171.png?v=1684622443',
 text: 'Certified Halal By HMA',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_170.png?v=1684622456',
 text: 'Support Local Ontario Farmers',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_169.png?v=1684622467',
 text: 'Fresh Ontario Sourced Produced',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_174.png?v=1684622299',
 text: 'No Hormones or Antibiotics',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_173.png?v=1684622421',
 text: '100% Grass Fed Beef',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_172.png?v=1684622432',
 text: 'Wild Caught & Organic Fish Sustainable Seafood',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_171.png?v=1684622443',
 text: 'Certified Halal By HMA',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_170.png?v=1684622456',
 text: 'Support Local Ontario Farmers',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_169.png?v=1684622467',
 text: 'Fresh Ontario Sourced Produced',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_174.png?v=1684622299',
 text: 'No Hormones or Antibiotics',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_173.png?v=1684622421',
 text: '100% Grass Fed Beef',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_172.png?v=1684622432',
 text: 'Wild Caught & Organic Fish Sustainable Seafood',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_171.png?v=1684622443',
 text: 'Certified Halal By HMA',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_170.png?v=1684622456',
 text: 'Support Local Ontario Farmers',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_169.png?v=1684622467',
 text: 'Fresh Ontario Sourced Produced',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_174.png?v=1684622299',
 text: 'No Hormones or Antibiotics',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_173.png?v=1684622421',
 text: '100% Grass Fed Beef',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_172.png?v=1684622432',
 text: 'Wild Caught & Organic Fish Sustainable Seafood',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_171.png?v=1684622443',
 text: 'Certified Halal By HMA',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_170.png?v=1684622456',
 text: 'Support Local Ontario Farmers',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_169.png?v=1684622467',
 text: 'Fresh Ontario Sourced Produced',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_174.png?v=1684622299',
 text: 'No Hormones or Antibiotics',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_173.png?v=1684622421',
 text: '100% Grass Fed Beef',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_172.png?v=1684622432',
 text: 'Wild Caught & Organic Fish Sustainable Seafood',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_171.png?v=1684622443',
 text: 'Certified Halal By HMA',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_170.png?v=1684622456',
 text: 'Support Local Ontario Farmers',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_169.png?v=1684622467',
 text: 'Fresh Ontario Sourced Produced',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_174.png?v=1684622299',
 text: 'No Hormones or Antibiotics',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_173.png?v=1684622421',
 text: '100% Grass Fed Beef',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_172.png?v=1684622432',
 text: 'Wild Caught & Organic Fish Sustainable Seafood',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_171.png?v=1684622443',
 text: 'Certified Halal By HMA',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_170.png?v=1684622456',
 text: 'Support Local Ontario Farmers',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_169.png?v=1684622467',
 text: 'Fresh Ontario Sourced Produced',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_174.png?v=1684622299',
 text: 'No Hormones or Antibiotics',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_173.png?v=1684622421',
 text: '100% Grass Fed Beef',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_172.png?v=1684622432',
 text: 'Wild Caught & Organic Fish Sustainable Seafood',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_171.png?v=1684622443',
 text: 'Certified Halal By HMA',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_170.png?v=1684622456',
 text: 'Support Local Ontario Farmers',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_169.png?v=1684622467',
 text: 'Fresh Ontario Sourced Produced',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_174.png?v=1684622299',
 text: 'No Hormones or Antibiotics',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_173.png?v=1684622421',
 text: '100% Grass Fed Beef',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_172.png?v=1684622432',
 text: 'Wild Caught & Organic Fish Sustainable Seafood',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_171.png?v=1684622443',
 text: 'Certified Halal By HMA',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_170.png?v=1684622456',
 text: 'Support Local Ontario Farmers',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_169.png?v=1684622467',
 text: 'Fresh Ontario Sourced Produced',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_174.png?v=1684622299',
 text: 'No Hormones or Antibiotics',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_173.png?v=1684622421',
 text: '100% Grass Fed Beef',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_172.png?v=1684622432',
 text: 'Wild Caught & Organic Fish Sustainable Seafood',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_171.png?v=1684622443',
 text: 'Certified Halal By HMA',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_170.png?v=1684622456',
 text: 'Support Local Ontario Farmers',
 },
 {
 name: '',
 image_url:
 'https://proteinchefs.com/cdn/shop/files/Retangulo_169.png?v=1684622467',
 text: 'Fresh Ontario Sourced Produced',
 },
 ];

 const style = `
 <style>
   .flag-image {
     max-width: 120px;
   }
   .protein_chief .contain_with_photo {
     width: 56% !important;
   }
   .protein_chief.jf-custom-hero {
     background-color: #ffffff !important;
   }
   .protein_chief .left_part h1 {
     font-weight: 700;
     font-size: 40px;
     line-height: 120%;
     text-transform: uppercase;
   }
   .protein_chief .left_part h1 {
     color: #0a0909;
     font-style: normal;
     font-weight: 800;
     text-transform: uppercase;
     margin-bottom: 25px !important;
   }
   .protein_chief .main_description {
     color: #0a0909;
     font-size: 24px !important;
     font-style: normal;
     font-weight: 300;
     line-height: 140% !important;
     margin-bottom: 30px;
   }
   .left_part a.btn {
     display: flex;
     width: 422px;
     height: 64px;
     padding: 12px 24px;
     justify-content: center;
     align-items: center;
     gap: 10px;
     text-decoration: none;
     border-radius: 50px;
     background: #f45f3b!important;
     color: #fff;
     font-size: 20px;
     font-style: normal;
     font-weight: 700;
     line-height: 24px;
     text-transform: uppercase;
   }
   .left_part a.btn:hover {
     background: transparent!important;
     color: #f45f3b !important;
   }
   .left_part {
     padding: 0 !important;
   }
   .hero-bottom {
     display: flex;
     justify-content: flex-start;
     align-items: center;
     background: #f3f4f6;
     gap: 15px;
     margin: 0;
     padding: 0;
     overflow: hidden;
   }

   .hero-bottom-main {
     display: flex;
     justify-content: center;
     align-items: center;
     gap: 40px;
     animation: scroll-left 555s linear infinite;
      width: max-content;
      white-space: nowrap;
      will-change: transform;
   }
   .hero-bottom-item img {
     width: 32px;
     height: 32px;
     aspect-ratio: 1 / 1;
   }
img.halal-image {
    width: 100%;
    height: auto;
    max-width: 100px;
    display: block;
}
   .HeroPara {
     color: #374151;
     text-align: center;
     font-size: 20px;
     font-style: normal;
     font-weight: 400;
     line-height: 140%;
     min-width: max-content;
     display: flex;
   }

   .hero-bottom-item {
     display: flex;
     justify-content: center;
     align-items: center;
     gap: 20px;
     padding: 20px;
   }

   .review {
     display: flex;
     gap: 8px;
   }
   .review {
     display: flex;
     justify-content: flex-start;
     gap: 8px;
   }
   .check-icon {
     display: flex;
   }
   .review-desc {
     color: var(--T-Shades-Black, #0a0909);
     font-size: 16px;
     font-style: normal;
     font-weight: 600;
     line-height: normal;
   }

   .silver.main_description p {
     color: #0a0909;
     font-weight: 300;
     font-size: 24px;
     line-height: 140%;
   }

   .list-sec {
     display: none!important;
   }

   .star {
     flex-shrink: 0;
   }

   @media (min-width: 768px) {
     .left_part {
       padding: 60px 0 !important;
       width: 75%!important;
     }
   }

   @media (max-width: 767px) {
     .flag-image {
      //  align-self: flex-start;
       position: relative;
       left: 0;
     }
     .flag-badge img {
          background-color: white;
          padding: 5px;
          border-radius: 5px;
          max-height: 56px;
          box-sizing: border-box;
      }
      .flag-badge {
        /* background-color: white; */
        padding: 5px;
        position: absolute !important;
        top: -75px;
        border-radius: 5px;
        left: 5px !important;
      }
    img.halal-image {
        max-width: 80px;
    }
     .hero-bottom {
      //  margin-bottom: 30px;
     }
     .protein_chief .left_part a {
       text-align: center;
       width: 100%;
       background-color: #0c0c0c;
       border-color: #0c0c0c;
       font-size: 18px !important;
     }
     .page-width {
       margin: 0 auto !important;
     }
     .review {
       display: flex;
       justify-content: center;
       gap: 8px;
       margin-bottom: 5px;
     }
     .review-desc {
       font-size: 12px;
       text-align: left;
     }
     .protein_chief .main_description {
       font-size: 16px !important;
       line-height: 22px;
       margin-bottom: 20px !important;
     }
     .check-desc {
       text-align: left;
       font-size: 16px;
     }
     .check-icon svg {
       width: 23px;
       height: 24px;
     }
     .protein_chief .left_part h1 {
       margin-bottom: 20px !important;
       font-size: 18px !important;
     }
     #MainContent .silver.main_description p {
       font-size: 16px;
       line-height: 18px;
     }
     .homepage_template .page-width {
       padding: 0 0px !important;
     }
     .homepage_template .protein_chief .contain_with_photo {
       margin-top: -20px;
       padding-bottom: 0px !important;
       margin-bottom: 20px !important;
       padding: 0 10px;
       padding-bottom: 50px !important;
       background: #ffffff;
     }
     .homepage_template .icon-sec.logo_with_title .logo_title {
       padding: 0 0 !important;
     }
     sticky-header.header-wrapper.color-background-1.gradient.header-wrapper--border-bottom {
       padding: 0 0px;
     }
     .homepage_template .protein_chief .contain_with_photo .left_part h1.orange {
       font-size: 22px !important;
     }
     .yotpo-widget-loyalty-floater-widget.yotpo-widget-override-css {
       display: none;
     }
     .item {
       background: white !important;
     }
   }

   @keyframes scroll-left {
     0% {
       transform: translateX(0%);
     }

     100% {
       transform: translateX(-100%);
     }
   }

 </style>
 `;
 const new_elm_htmlAutoSliding = `
 <div class="hero-bottom">
   <div class="hero-bottom-main">
     ${slidingElement
     .map(
     (slidingEl) => `
     <div class="hero-bottom-item">
       <img src="${slidingEl.image_url}" alt="" srcset="${slidingEl.image_url}">
       <div class="HeroPara">${slidingEl.text}</div>
     </div>
     `
     )
     .join('')}
   </div>
 </div>
 `;

 const starSvg = `
 <svg class="star" width="98" height="18" viewBox="0 0 98 18" fill="none" xmlns="http://www.w3.org/2000/svg">
   <path d="M9 0L11.645 5.35942L17.5595 6.21885L13.2798 10.3906L14.2901 16.2812L9 13.5L3.70993 16.2812L4.72025 10.3906L0.440492 6.21885L6.35497 5.35942L9 0Z" fill="#F35E39"/>
   <path d="M29 0L31.645 5.35942L37.5595 6.21885L33.2798 10.3906L34.2901 16.2812L29 13.5L23.7099 16.2812L24.7202 10.3906L20.4405 6.21885L26.355 5.35942L29 0Z" fill="#F35E39"/>
   <path d="M49 0L51.645 5.35942L57.5595 6.21885L53.2798 10.3906L54.2901 16.2812L49 13.5L43.7099 16.2812L44.7202 10.3906L40.4405 6.21885L46.355 5.35942L49 0Z" fill="#F35E39"/>
   <path d="M69 0L71.645 5.35942L77.5595 6.21885L73.2798 10.3906L74.2901 16.2812L69 13.5L63.7099 16.2812L64.7202 10.3906L60.4405 6.21885L66.355 5.35942L69 0Z" fill="#F35E39"/>
   <path d="M89 0L91.645 5.35942L97.5595 6.21885L93.2798 10.3906L94.2901 16.2812L89 13.5L83.7099 16.2812L84.7202 10.3906L80.4405 6.21885L86.355 5.35942L89 0Z" fill="#F35E39"/>
 </svg>
 `;
  const flag = `
    <div class="flag-badge">
      <img 
        src="https://cdn.shopify.com/s/files/1/0603/9735/5095/files/Safari2025-06-12_at_05.56PM_1.png?v=1749828971"
        alt="flag"
        class="flag-image"
      >
      <img 
        src="https://cdn.shopify.com/s/files/1/0758/6702/9808/files/halal_logo.png?v=1769584367"
        alt="halal"
        class="halal-image"
      >
    </div>
 `;
  const new_elm_html = `
 <div style="margin-top: 15px;" class="color-text">
   <div class="review">
     ${starSvg}
     <div class="review-desc">Rated 5.0 by 400+ Happy Customers!</div>
   </div>
 </div>
 `;

 const head = document.querySelector('head');
 if (head) {
 head.insertAdjacentHTML('beforeend', style);
 }

  const exist_elm = document.querySelector('.protein_chief .left_part h1.orange');
  const DsktpBgImg = document.querySelector('.jf-custom-hero');
  const MobileBgImg = document.querySelector('.mobile-image img');
  const btnTxt = document.querySelector('.left_part a.btn');
  if (exist_elm && !document.querySelector('.color-text')) {
    DsktpBgImg.style.backgroundImage = `url('${DesktopBackgroundImageURL}')`;
    MobileBgImg.src = MobileBackgroundImageURL;
    MobileBgImg.srcset = MobileBackgroundImageURL;

    exist_elm.insertAdjacentHTML('beforebegin', flag);
    btnTxt.insertAdjacentHTML('afterend', new_elm_html)
    
    document.querySelectorAll('.image_text_wrapper .item').forEach((e) => {
      e.style.backgroundColor = '#FFF8F4';
      e.style.padding = '20px 30px';
    });
    btnTxt.innerText = btnText;
  }

 const exist_elmAutoSliding = document.querySelector(
 '.logo_with_title.icon-sec'
 );
 if (exist_elmAutoSliding && !document.querySelector('.hero-bottom')) {
 exist_elmAutoSliding.innerHTML = new_elm_htmlAutoSliding;
 }

  } catch(e) { console.error(e); }
})();
})();
